import styled from "@emotion/styled";
import { lightGreen, white } from "@stepfinance/react";
import { Modal as BaseModal } from "antd";
import type { FC } from "react";
import React from "react";

import { ReactComponent as ModalCloseSVG } from "../../assets/ModalClose.svg";

export interface ModalProps {
  children: React.ReactNode;
  title: string;
  TitleIcon?: React.ElementType;
  onClose: () => void;
  width: number;
  visible: boolean;
  className?: string;
}

export const Modal: FC<ModalProps> = ({ children, title, TitleIcon, onClose, width, visible, className }) => {
  return (
    <>
      <StepModal
        title={
          <TitleContainer>
            {TitleIcon && (
              <div className="title-icon">
                <TitleIcon />
              </div>
            )}
            <span>{title}</span>
          </TitleContainer>
        }
        onCancel={onClose}
        width={width}
        visible={visible}
        className={className}
        footer={null}
        closeIcon={<ModalCloseSVG />}
        centered
        // Without this prop it seems like the modal gets re-rendered after being closed, which is a bug. This seemed the easiest fix
        destroyOnClose={true}
        maskClosable={true}
      >
        {children}
      </StepModal>
    </>
  );
};

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  color: ${white};
  .title-icon {
    margin-right: 12px;
    > svg {
      path {
        fill: ${lightGreen};
      }
    }
    width: 28px;
    height: 28px;
  }
`;

const StepModal = styled(BaseModal)`
  .ant-modal-content {
    border-radius: 8px;
  }
  .ant-modal-header {
    border-bottom: none;
    border-radius: 8px;
    padding: 18px 0 20px 20px;
  }
  .ant-modal-close {
    top: 7px;
    right: 5px;
  }
  .ant-modal-body {
    padding: 0px 20px 20px 20px;
  }
`;
